/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    shape, string, number, bool,
    array,
} from 'prop-types';
import Media from 'react-media';
import { compose } from 'recompose';
import { makeStyles } from '@material-ui/core/styles';
import loadable from '@loadable/component';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import { trackData } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import GraphqlAfterProductBanner from '../../GraphqlCategoryPage/Partials/GraphqlAfterProductBanner/GraphqlAfterProductBanner';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const RadioOfferResultsMobilePage = loadable(() => import(/* webpackChunkName: "RadioOfferResultsMobilePage" */ './RadioOfferResultsMobilePage'));
const RadioOfferResultsDesktopPage = loadable(() => import(/* webpackChunkName: "RadioOfferResultsDesktopPage" */ './RadioOffersResultDesktopPage'));

const useStyles = makeStyles(() => ({
    bottomBannerContainer: {
        maxWidth: '1430px',
        width: '100%',
    },
}));

const RadioOffersResultBlock = ({
    breakpoint,
    mainCollection,
    data,
    featureCollection,
    listenerFavorites,
    loadComponent,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    trackData({
        action: 'track_radio_interstitial_page_results_data',
    });
    if (featureCollection) {
        dispatch(trackEvent({
            eventCategory: 'Radio Personality',
            eventAction: 'Personality Page Visit',
            eventLabel: '<<Radio Personality>>',
            nonInteraction: '1',
        }));
    }
    const ssrDeviceType = useSelector(getSSRDeviceType);

    const breakpointExpr =  `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabPortrait)}px)`;
    let productPerRowDesktop = { products_per_row: 3 };
    productPerRowDesktop = data?.product_layout?.find((block) => (ssrDeviceType === 'mobile' ?  block?.name?.includes('Mobile') :  block?.name?.includes('Desktop')));
    const showLeftRailContent = ssrDeviceType !== 'mobile' && data?.modular_blocks?.some((block) => ((block?.related_articles || block?.related_searches || block?.side_rail_banner)));

    const bottomBanner = (item) => {
        if (!item) {
            return null;
        }
        const blockKey = Object.keys(item)[0];
        switch (blockKey) {
            case 'banner':
            {
                return (
                    <div className={classes.bottomBannerContainer}>
                        <GraphqlAfterProductBanner bannerBlock={item?.banner} />
                    </div>
                );
            }
            default:
                return null;
        }
    };

    const blocksData = {
        page_blocks: data?.modular_blocks || [],
    };

    return (
        <Media
            query={breakpointExpr}
        >
            {(matches) => (
                matches ? (
                    <RadioOfferResultsMobilePage
                        bestSeller={mainCollection?.products}
                        bannerImage={data?.banner_image_name}
                        title={data?.banner_image_name}
                        nameFeature={featureCollection?.name}
                        productFeature={featureCollection?.products}
                        productFavorites={listenerFavorites?.products}
                        copy={data?.copy}
                        nameFavorite={listenerFavorites?.name}
                        numOfProduct={productPerRowDesktop?.products_per_row}
                        loadComponent={loadComponent}
                        blocksData={blocksData}
                        isMobile={ssrDeviceType === 'mobile'}
                        bottomBanner={bottomBanner}
                    />

                ) : (
                    <RadioOfferResultsDesktopPage
                        mainCollection={mainCollection}
                        data={data}
                        featureCollection={featureCollection}
                        listenerFavorites={listenerFavorites}
                        loadComponent={loadComponent}
                        showLeftRailContent={showLeftRailContent}
                        blocksData={blocksData}
                        bottomBanner={bottomBanner}
                        productPerRowDesktop={productPerRowDesktop}
                    />
                )
            )}
        </Media>
    );
};

RadioOffersResultBlock.propTypes = {
    mainCollection: shape({
        name: string.isRequired,
        products: array.isRequired,
    }).isRequired,
    featureCollection: shape({
        name: string.isRequired,
        products: array.isRequired,
    }).isRequired,
    listenerFavorites: shape({
        name: string.isRequired,
        products: array.isRequired,
    }).isRequired,
    data: shape({
        banner_image_name: string,
        title: string,
    }),
    breakpoint: number,
    loadComponent: bool,
};

RadioOffersResultBlock.defaultProps = {
    breakpoint: CUSTOM_BREAKPOINTS.tabPortrait,
    loadComponent: true,
    data: {},
};

const enhance = compose(
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(RadioOffersResultBlock);
